import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../cn.js';
const STATE_TONE = {
    pending: 'bg-tertiary-fixed text-on-tertiary-fixed',
    in_flight: 'bg-primary-container text-on-primary',
    synced: 'bg-secondary-container text-on-secondary-container',
    failed: 'bg-error-container text-on-error-container',
    drifted: 'bg-error-container text-on-error-container',
};
const STATE_LABEL = {
    pending: 'Pending',
    in_flight: 'In flight',
    synced: 'Synced',
    failed: 'Failed',
    drifted: 'Drifted',
};
export function SyncStateBadge({ state, className }) {
    // state is a typed-union prop — bracket lookups are safe.
    /* eslint-disable security/detect-object-injection */
    const label = STATE_LABEL[state];
    const tone = STATE_TONE[state];
    /* eslint-enable security/detect-object-injection */
    return (_jsx("span", { role: "status", "aria-label": `Sync state: ${label}`, "data-sync-state": state, className: cn('inline-flex items-center px-2 py-1 rounded-full font-label-md text-label-md uppercase', tone, className), children: label }));
}
//# sourceMappingURL=SyncStateBadge.js.map